module.exports = __webpack_public_path__ + "files/db68240cc0d5750dc7bd3017b5cd99c1.svg";